export enum Visning {
  GRID_BREAKPOINT_XS = 0,
  GRID_BREAKPOINT_SM = 575,
  GRID_BREAKPOINT_MD = 768, // Standard Mobile View
  GRID_BREAKPOINT_LG = 992,
  GRID_BREAKPOINT_XL = 1200,
  GRID_BREAKPOINT_XXL = 1400
}
